import AppContext from "PFApp/app_context";
import React, { useCallback, useContext } from "react";

import ApprovalsListView from "./approvals_list_view";
import ApproveModal from "./modals/approve";
import RejectApprovalModal from "./modals/reject_approval";
import RequestApprovalModal from "./modals/request_approval";

const MODALS = {
  approve: ApproveModal,
  rejectApproval: RejectApprovalModal,
  requestApproval: RequestApprovalModal
};

const Approvals = () => {
  const {
    store: {
      pages: {
        booking: {
          approvals: { modalData, openModal }
        }
      }
    }
  } = useContext(AppContext);

  const closeModal = useCallback(() => openModal(null), [openModal]);
  const ModalComponent = modalData?.actionType && MODALS[modalData.actionType];

  return (
    <>
      <ApprovalsListView />
      {ModalComponent && <ModalComponent {...modalData} handleClose={closeModal} />}
    </>
  );
};

export default Approvals;
